/**
 * batchCodes — a WIP's batch code, resolved WITHOUT the lookup expansion.
 *
 * Its own module with ZERO imports, for the same reason snapshotPolicy is:
 * ProductionGridService pulls in MSAL config and the environment variables
 * behind it, so nothing that imports it can be unit-tested. The rule here is
 * load-bearing enough to need tests — see below.
 *
 * WHY THIS EXISTS AT ALL. Expanding the BatchID lookup while paging a
 * 17,000-row list turns the read into a crawl; PR #658 fixed exactly that on
 * listWipsSewerView, where the subcon breakdown sat on its loading line and
 * never came back. The same expand was still on listWips — the read every
 * BQC1 screen makes on load. Dropping it is only safe if the code still
 * arrives by another route, because a batch that quietly loses its code looks
 * exactly like a batch nobody assigned.
 */

/** Just enough of a batch header to index it. */
export interface IBatchCodeSource {
  /** The SharePoint list id a WIP's BatchIDId points at. */
  spId?: number;
  batchCode: string;
}

/**
 * Batch list id → batch code.
 *
 * A header with no id or no code contributes NOTHING: an entry either way
 * would resolve a real batch to an empty string, which reads on screen as a
 * code that was deleted rather than one that was never there.
 */
export function batchCodeIndex(headers: readonly IBatchCodeSource[]): Map<number, string> {
  const out = new Map<number, string>();
  for (const b of headers) {
    if (b.spId === undefined || !b.batchCode) continue;
    out.set(b.spId, b.batchCode);
  }
  return out;
}
